import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { timeline } from "@/mocks/feed";

const categoryColor: Record<string, string> = {
  明星: "bg-primary-100 text-primary-700",
  网红: "bg-secondary-100 text-secondary-900",
  综艺: "bg-accent-100 text-accent-800",
  影视: "bg-background-200 text-foreground-800",
  品牌: "bg-primary-50 text-primary-700",
  争议: "bg-foreground-100 text-foreground-800",
};

export default function Timeline() {
  const [expanded, setExpanded] = useState(false);
  const visible = expanded ? timeline : timeline.slice(0, 5);

  return (
    <section id="timeline" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <SectionHeading
        eyebrow="LIVE · 最新爆料"
        title="最新爆料时间线"
        desc="按时间倒序记录每天的讨论热点，保留时间、分类与一句话说明，方便你顺着时间线理清事件走向。"
      />

      <div className="mt-8 relative">
        <div className="absolute left-[7px] top-2 bottom-2 w-px bg-background-300" aria-hidden="true" />
        <ul className="space-y-4">
          {visible.map((item) => (
            <li key={item.id} className="relative pl-8">
              <span className="absolute left-0 top-4 w-3.5 h-3.5 rounded-full bg-background-50 border-2 border-primary-500" />
              <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5 hover:border-primary-300 transition-colors">
                <div className="flex flex-wrap items-center gap-x-3 gap-y-2 mb-2">
                  <span className="font-label text-sm text-foreground-500">
                    {item.date} {item.time}
                  </span>
                  <span
                    className={`text-xs px-2 py-0.5 rounded-md ${
                      categoryColor[item.category] ?? "bg-foreground-100 text-foreground-800"
                    }`}
                  >
                    {item.category}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>

      <div className="mt-6 flex justify-center">
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="inline-flex items-center gap-2 bg-background-50 border border-background-300 hover:border-primary-400 text-foreground-800 hover:text-primary-700 text-sm font-medium px-5 py-2.5 rounded-md transition-colors cursor-pointer whitespace-nowrap"
        >
          <i className={expanded ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"} />
          {expanded ? "收起，只看最近更新" : `展开更早的 ${timeline.length - 5} 条爆料`}
        </button>
      </div>
    </section>
  );
}